module.exports = __webpack_public_path__ + "img/small.fb87cd77.png";